import {Injectable} from "@angular/core";
import {Http, URLSearchParams} from "@angular/http";
import {UserService} from "./user.service";

@Injectable()
export class FirmwareService {
    private getFirmwaresUrl = 'api/firmware-upload/v1/';
    public postFirmwareDataUrl:string;
    public postFirmwareFileUrl:string;

    constructor(
        private http: Http,
        private user: UserService
    ) {
        this.postFirmwareDataUrl = 'api/firmware-upload/v1/upload-data?token=' + this.user.token;
        this.postFirmwareFileUrl = 'api/firmware-upload/v1/upload-file?token=' + this.user.token;
    }

    public postFirmwareData(data){
        return this.http.post(
                this.postFirmwareDataUrl,
                data
            )
            .map(
                result => result,
                error => error
            );
    }

    public getFirmwares(options={}){
        let args = new URLSearchParams();

        for(let item in options)
        {
            args.set(item, options[item]);
        }

        return this.http.get(
            this.getFirmwaresUrl,
            {
                search: args
            }
        ).map(
            result => result.json(),
            error => error
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/services/api_v1/firmware.service.ts